"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var RoleName;
(function (RoleName) {
    RoleName["ligrAdmin"] = "ligrAdmin";
    RoleName["owner"] = "owner";
    RoleName["admin"] = "admin";
    RoleName["operator"] = "operator";
    RoleName["user"] = "user";
    RoleName["overlay"] = "overlay";
})(RoleName = exports.RoleName || (exports.RoleName = {}));
exports.roleAccess = {
    ligrAdmin: [RoleName.ligrAdmin, RoleName.owner, RoleName.admin, RoleName.operator, RoleName.user],
    owner: [RoleName.owner, RoleName.admin, RoleName.operator, RoleName.user, RoleName.overlay],
    admin: [RoleName.admin, RoleName.operator, RoleName.user, RoleName.overlay],
    operator: [RoleName.operator, RoleName.user],
    user: [RoleName.user],
    overlay: [RoleName.overlay]
};
//# sourceMappingURL=Role.js.map